import { css } from "styled-components";

const Inter = css`
  font-family: Inter, sans-serif;
  font-style: normal;
`;

export const Inter_40_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 40px;
  line-height: 40px;
`;

export const Inter_24_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
`;

export const Inter_20_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
`;

export const Inter_18_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
`;

export const Inter_14_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;

export const Inter_14_600 = css`
  ${Inter};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const Inter_14_500 = css`
  ${Inter};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const Inter_14_400 = css`
  ${Inter};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const Inter_12_700 = css`
  ${Inter};
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
`;
export const Inter_12_600 = css`
  ${Inter};
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`;

export const Inter_12_500 = css`
  ${Inter};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;

export const Inter_12_400 = css`
  ${Inter};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

const Overpass_Mono = css`
  font-family: "Overpass Mono", sans-serif;
  font-style: normal;
`;

export const Overpass_Mono_14_500 = css`
  ${Overpass_Mono};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
`;

export const Overpass_Mono_14_400 = css`
  ${Overpass_Mono};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
`;

export const Overpass_Mono_12_500 = css`
  ${Overpass_Mono};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.2px;
`;

export const Overpass_Mono_12_400 = css`
  ${Overpass_Mono};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.2px;
`;
